import { apiDelete, apiGet, apiPost, apiPut } from '@/shared/utils/requestBuilder';

interface Delegacao {
  id: string;
  usuarioId: string;
  delegadoId: string;
  ativo: boolean;
  observacoes?: string;
  dataCriacao: string;
  dataAtualizacao: string;
  delegado: {
    id: string;
    nomeCompleto: string;
    email: string;
    tipoUsuario: string;
    ativo: boolean;
  };
}

interface CreateDelegacaoDto {
  delegadoId: string;
  observacoes?: string;
}

interface UpdateDelegacaoDto {
  ativo?: boolean;
  observacoes?: string;
}

export const delegacaoService = {
  listarPorUsuario: async (usuarioId: string): Promise<Delegacao[]> => {
    const response = await apiGet(`/usuarios/${usuarioId}/delegacoes`);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao listar delegações' }));
      throw new Error(errorData.error || 'Erro ao listar delegações');
    }

    const result = await response.json();
    return result.data;
  },

  criar: async (data: CreateDelegacaoDto): Promise<Delegacao> => {
    const response = await apiPost('/delegacoes', data);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao criar delegação' }));
      throw new Error(errorData.error || 'Erro ao criar delegação');
    }

    const result = await response.json();
    return result.data;
  },

  atualizar: async (id: string, data: UpdateDelegacaoDto): Promise<Delegacao> => {
    const response = await apiPut(`/delegacoes/${id}`, data);

    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao atualizar delegação' }));
      throw new Error(errorData.error || 'Erro ao atualizar delegação');
    }

    const result = await response.json();
    return result.data;
  },

  remover: async (id: string): Promise<void> => {
    const response = await apiDelete(`/delegacoes/${id}`);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao remover delegação' }));
      throw new Error(errorData.error || 'Erro ao remover delegação');
    }
  },
};
